import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/company";

export const Route = createFileRoute("/panaszkezeles")({
  head: () => ({
    meta: [
      { title: "Panaszkezelési tájékoztató | LAKROSZ Autószerviz" },
      {
        name: "description",
        content:
          "A LAKROSZ Autószerviz panaszkezelési tájékoztatója: hol és hogyan tehet panaszt az ügyfél, és milyen határidőkkel kezeljük.",
      },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Panaszkezelési tájékoztató | LAKROSZ Autószerviz" },
      {
        property: "og:description",
        content: "Panasz benyújtásának módjai, kivizsgálás menete, békéltető testület.",
      },
      { property: "og:url", content: "https://lakroszautoszerviz.com/panaszkezeles" },
      { property: "og:type", content: "article" },
    ],
    links: [
      { rel: "canonical", href: "https://lakroszautoszerviz.com/panaszkezeles" },
    ],
  }),
  component: ComplaintsPage,
});

function ComplaintsPage() {
  return (
    <LegalLayout
      title="Panaszkezelési tájékoztató"
      subtitle={`Utolsó frissítés: ${COMPANY.lastUpdated}`}
    >
      <section>
        <h2 className="font-display text-2xl mt-4 mb-3">1. Panasz benyújtása</h2>
        <p>Az ügyfél panaszát az alábbi módokon nyújthatja be a szolgáltatóhoz:</p>
        <ul className="list-disc pl-6 space-y-1 mt-2">
          <li>személyesen a telephelyen</li>
          <li>telefonon</li>
          <li>e-mailben</li>
          <li>írásban (postai úton)</li>
        </ul>
        <div className="mt-4 rounded-2xl border border-border bg-surface p-6">
          <p className="text-sm">
            <strong>Telephely:</strong> 3300 Eger, Vécseyvölgy utca 99.
            <br />
            <strong>Telefon:</strong>{" "}
            <a className="text-primary" href={COMPANY.contact.phoneHref}>
              {COMPANY.contact.phone}
            </a>
            <br />
            <strong>E-mail:</strong>{" "}
            <a className="text-primary" href={`mailto:${COMPANY.contact.email}`}>
              {COMPANY.contact.email}
            </a>
          </p>
        </div>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">2. Panasz kivizsgálása</h2>
        <p>
          A szolgáltató a panaszt a lehető legrövidebb időn belül kivizsgálja, és legfeljebb
          30 napon belül írásban válaszol.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">3. A panasz tartalma</h2>
        <p>A panaszban érdemes megadni:</p>
        <ul className="list-disc pl-6 space-y-1 mt-2">
          <li>az ügyfél neve</li>
          <li>elérhetősége (telefon, e-mail)</li>
          <li>jármű típusa és rendszáma, ha releváns</li>
          <li>a szolgáltatás időpontja</li>
          <li>a panasz részletes leírása</li>
          <li>fényképek, dokumentumok, ha rendelkezésre állnak</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">4. Békéltető testület</h2>
        <p>
          Amennyiben a fogyasztó nem ért egyet a szolgáltató válaszával, vagy a panasz
          rendezése nem vezet eredményre, jogosult a lakóhelye vagy tartózkodási helye szerint
          illetékes békéltető testülethez fordulni.
        </p>
        <div className="mt-4 rounded-2xl border border-border bg-surface p-6 text-sm">
          <p>
            <strong>Illetékes békéltető testület:</strong>{" "}
            Borsod-Abaúj-Zemplén Vármegyei Kereskedelmi és Iparkamara által működtetett Békéltető Testület
            <br />
            <strong>Cím:</strong>{" "}
            3530 Miskolc, Szentpáli utca 1.
            <br />
            <strong>Weboldal:</strong>{" "}
            <a className="text-primary" href="https://www.bokik.hu" target="_blank" rel="noopener noreferrer">
              https://www.bokik.hu
            </a>
          </p>
        </div>
      </section>

      <section>
        <h2 className="font-display text-2xl mt-8 mb-3">5. Együttműködés</h2>
        <p>
          A szolgáltató fogyasztói jogvita esetén együttműködik a jogszabályokban előírt
          módon.
        </p>
      </section>
    </LegalLayout>
  );
}
